/**
 * This is an example for rendering component
 * Remove it, when the React component will be merged
 */
const DefaultPlaceholderComponent = () => {
  return <></>;
};

export default DefaultPlaceholderComponent;
